import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import AdminCheck from "../AdminCheck";
import { exportTransactions } from "./XLSXPurchaseExporter";
import { useDocCollection } from "../../Firebase/useDoc";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import { PurchaseHistoryData } from "functions/src/shared/Digital/User/PurchaseHistoryData";
import MajorButton from "../../Utility/MajorButton";
import { PaymentGateWay } from "functions/src/shared/Digital/Payment";
export default function AdminExportPurchasePageWrapper() {
  return (
    <AdminCheck fallback={<div></div>}>
      <AdminExportPurchasePage></AdminExportPurchasePage>
    </AdminCheck>
  );
}
function AdminExportPurchasePage() {
  const now = new Date();
  const previousMonth = new Date(now.getFullYear(), now.getMonth());
  const firstDayOfPreviousMonth = new Date(
    now.getFullYear(),
    now.getMonth() - 1,
    2
  );
  console.log(firstDayOfPreviousMonth.toISOString());

  const [startDate, setStartDate] = React.useState<string>(
    firstDayOfPreviousMonth.toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = React.useState<string>(
    previousMonth.toISOString().split("T")[0]
  );
  // const [currency, setCurrency] = React.useState<string>("TWD");
  const [fileStr, setfileStr] = React.useState<string>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const LoadPurchaseHistory = async (jsonText: any) => {
    var transcations = [];
    var startTime = new Date(startDate + " 00:00:00+8").getTime();
    var endTime = new Date(endDate + " 23:59:59+8").getTime();
    console.log("between", new Date(startTime), new Date(endTime));

    //交易時間
    // const snapshot = await purchaseHistoryCollection
    //   .where("create_at", ">=", startTime)
    //   .where("create_at", "<=", endTime)
    //   .get();

    // const { collection: purchaseHistoryCollection, collectionData } =
    //   useDocCollection<PurchaseHistoryData>(
    //     "purchaseHistory",
    //     where("credited", ">=", startTime),
    //     where("credited", "<=", endTime)
    //   );
    //入帳時間
    const firestore = getFirestore();
    const docsRef = collection(firestore, "purchaseHistory");
    const q = query(
      docsRef,
      where("credited", ">=", startTime),
      where("credited", "<=", endTime),
      where("gw", "==", gw)
      // where("campaign_slug", "!=", "ninesols")
    );
    //TODO: 只撈哪塊?
    const result = getDocs(q);
    // const snapshot = get
    const snapshots = (await result).docs;
    const docData = snapshots.map((doc) => {
      var data = doc.data() as PurchaseHistoryData;
      data.id = doc.id;
      return data;
    });
    for (var data of docData) {
      transcations.push(data);
    }

    console.log("Transactions", startDate, endDate, transcations);

    //Local approach
    // var objs = JSON.parse(jsonText);
    // const purchaseHistory = objs.purchaseHistory;
    // var keys = Object.keys(purchaseHistory);
    // for (var key of keys) {
    //   purchaseHistory[key].id = key;
    //   transcations.push(purchaseHistory[key]);
    // }

    exportTransactions(transcations, {
      startDate: startDate,
      endDate: endDate,
    });
  };
  const [gw, setGw] = React.useState<PaymentGateWay>("Cybersource");
  const gateWays: PaymentGateWay[] = ["Cybersource", "PayPal", "PayNow"];
  return (
    // <AdminCheck fallback={<div>權限不足</div>}>
    <div>
      {/* 讀取database備份資料:
      <div>
        <input
          type="file"
          accept="json"
          onChange={(evt) => {
            var tgt = evt.target;
            var files = tgt.files;
            if (FileReader && files && files.length) {
              var fr = new FileReader();
              fr.onload = function () {
                setfileStr(fr.result as string);
                setLoading(false);
              };
              fr.readAsText(files[0]);
              setLoading(true);
            }
          }}
        ></input>
      </div> */}
      <div>
        <Typography variant="h5">匯出當月報表</Typography>
        <hr></hr>
        <RadioGroup
          value={gw}
          // defaultValue={checkOutCtx.paymentGateWay || filteredGateWays[0]}
          style={{ paddingBottom: 12 }}
        >
          {gateWays.map((gw) => {
            return (
              <FormControl key={gw} style={{ width: "100%" }}>
                <FormControlLabel
                  id={"select_gateway_" + gw + "_text"}
                  value={gw}
                  labelPlacement={"end"}
                  label={<Typography>{gw}</Typography>}
                  // checked={checked}
                  control={
                    <Radio
                      id={"select_gateway_" + gw + "_radiobutton"}
                      onClick={() => {
                        setGw(gw);
                        // onClick();
                        // projectCtx.setPledgeOptionID(pledgeOption.slug);
                        // projectCtx.setPledgeOptionData(pledgeOption);
                      }}
                      style={{ alignSelf: "baseline" }}
                    ></Radio>
                  }
                ></FormControlLabel>
              </FormControl>
            );
          })}
        </RadioGroup>
        <div>
          <TextField
            //   id="datetime-local"
            fullWidth
            label="開始"
            type="date"
            defaultValue={startDate}
            // className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              new Date();
              console.log("Start Time", e.target.value);
              setStartDate(e.target.value);
            }}
          />
          <TextField
            //   id="datetime-local"
            fullWidth
            label="結束"
            type="date"
            defaultValue={endDate}
            // className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              console.log("End Time", e.target.value);
              setEndDate(e.target.value);
            }}
          />
          {/* <SimpleSelect
          value={currency}
          name="currency"
          options={["TWD", "USD"]}
          onChange={e => {
            setCurrency(e.target.value);
          }}
        ></SimpleSelect> */}
        </div>
        <MajorButton
          disabled={loading}
          onClick={() => {
            // FileReader support
            LoadPurchaseHistory(fileStr);
          }}
        >
          匯出
        </MajorButton>
      </div>
    </div>
  );
}
